<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      :rowKey="(text, index) => index"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
    </BTable>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'SwapManage',
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        const request = {
          ...this.queryParam
        }
        return this.$http.swap.rateRecordQueryPage(Object.assign(parameter, { request })).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        {
          label: '商户简称',
          key: 'merchantNo',
          type: 'select',
          options: this.$http.swap.merchantSimpleNameQueryList(),
          optionKey: 'merchantNo',
          optionValue: 'merchantSimpleName'
        },
        {
          label: '汇率渠道',
          key: 'channelNo',
          type: 'select',
          options: this.$http.swap.rateChannelQueryList(),
          optionKey: 'channelNo',
          optionValue: 'channelName'
        },
        {
          label: '卖出币种',
          key: 'sellCurrency',
          type: 'select',
          options: [],
          optionKey: 'currencyCode',
          optionValue: 'currencyName',
          keyValue: true
        }, {
          label: '买入币种',
          key: 'buyCurrency',
          type: 'select',
          options: [],
          keyValue: true,
          optionKey: 'currencyCode',
          optionValue: 'currencyName'
        }
      ],
      columns: [
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '商户简称',
          dataIndex: 'merchantDesc' // no
        },
        {
          title: '卖出币种',
          dataIndex: 'sellCurrency'
          // sorter: true,
          // needTotal: true,
          // customRender: (text) => text + ' 次'
        },
        {
          title: '买入币种',
          dataIndex: 'buyCurrency'
          // needTotal: true
        },
        {
          title: '商户汇率', // 请求接口？
          dataIndex: 'rate'
        },
        {
          title: '渠道汇率',
          dataIndex: 'channelRate'
          // customRender: () => '没有'
        },
        {
          title: '汇率渠道',
          dataIndex: 'channelDesc'
        },
        {
          title: '创建日期',
          dataIndex: 'createTime'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   width: '150px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  async created () {
    await this.getQueryParams()
  },
  methods: {
    async getQueryParams () {
      const params = { request: {} }
      try {
        const currencyRes = await this.$http.swap.queryAllCurrencyConf(params)
        // 币种
        const { data: currencyList } = currencyRes
        const sellSelect = this.searchList[2]
        const buySelect = this.searchList[3]
        this.$set(this.searchList, 2, Object.assign({}, sellSelect, { options: currencyList }))
        this.$set(this.searchList, 3, Object.assign({}, buySelect, { options: currencyList }))
      } catch (e) {
        // console.log(e)
      }
    },
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style scoped lang="less">
</style>
